module.exports = __webpack_public_path__ + "img/fire.f3b2b3c7.svg";